export default __webpack_public_path__ + "static/media/Renowned.d23b9657.png";